import {Component, OnInit} from '@angular/core';
import {DataOrdenamientosMedicamentosControladosEntity, FitlrosOrdenMedicamentosControladosEntity, ParametrosOrdenamientosEntity, ServicioOrdenamientosService} from 'src/app/services/servicio-ordenamientos.service';
import {ActivatedRoute} from '@angular/router';
import {EntidadEmpresarialEntity, ServicioEntidadService} from 'src/app/services/servicio-entidad.service';
import {ImagesService} from 'src/app/services/utils/images.service';
import {HttpErrorResponse} from '@angular/common/http';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-reporte-orden-medicamentos-controlados',
  templateUrl: './reporte-orden-medicamentos-controlados.component.html',
  styleUrls: ['./reporte-orden-medicamentos-controlados.component.css']
})
export class ReporteOrdenMedicamentosControladosComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private ordenamientosService: ServicioOrdenamientosService,
              private servicioEntidad: ServicioEntidadService,
              private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.uncoHc = Number(params['uncoHc']);
    });
  }

  firstAperturaReport: boolean;
  bodyPromise: Promise<any>;
  filtros: FitlrosOrdenMedicamentosControladosEntity;
  parametros: ParametrosOrdenamientosEntity = {} as ParametrosOrdenamientosEntity;
  entidadEmpresarial: EntidadEmpresarialEntity = {descripcion: ''} as EntidadEmpresarialEntity;
  infoOrdenamiento: DataOrdenamientosMedicamentosControladosEntity = {afiliado: {}} as DataOrdenamientosMedicamentosControladosEntity;

  profesionales: SelectItem[];

  now = new Date();
  mensajeLoading = 'Cargando...';
  mensajeError: string;
  logo: string;

  // variables body report
  profesional: string;
  indicaciones: string;
  nombreMedicamento: string;
  especialidad: string;
  fechaOrden: string;
  dgnstco: string;
  dgnstcor1: string;
  registroMedico: string;
  via: string;
  formaFarmaceutica: string;
  cantidadPrescritaNumerica: string;
  cantidadPrescritaAlfabetica: string;
  concentracion: string;
  cnsctvo_mcmnts_ctrlds: string;
  display: string = 'none' as string;


  public static getParameterByName(name: string) {

    // tslint:disable-next-line:indent
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

    // tslint:disable-next-line:indent
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(window.location.href);

    // tslint:disable-next-line:indent
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  ngOnInit() {

    const status = ReporteOrdenMedicamentosControladosComponent.getParameterByName('status');
    this.firstAperturaReport = status === 'true';
    if (this.firstAperturaReport) {

      this.bodyPromise = new Promise((resuelve) => {
        window.addEventListener('message', (event) => {

          try {
            if (event.origin !== window.location.origin) {

              const dataMessage = JSON.parse(event.data).data;
              // @ts-ignore
              event.source.postMessage('OK', event.origin);
              resuelve(dataMessage);

              this.infoOrdenamiento = <DataOrdenamientosMedicamentosControladosEntity>{
                afiliado: dataMessage.afiliado
              };

              this.restartSession();

            }
          } catch (e) {
            console.error('Catch ReporteOrdenMedicamentosControladosComponent.ngOnInit()', e);
          }
        });
      });

    } else {
      this.getAfiliado();
    }

    this.getLogo();
  }


  restartSession() {
    const currURL = window.location.href,
      currentURL = window.location.href;

    if (currURL.indexOf('?') !== -1) {
      window.history.replaceState('', '', currentURL.slice(0, - 12) + '?status=' + false);
      this.firstAperturaReport = false;
    }
  }

  changeProfesional() {
    this.display = 'none';
  }

  onFiltrosCompletados(filtros: FitlrosOrdenMedicamentosControladosEntity) {

    this.filtros = filtros;
    this.display = 'revert';

    if (!this.firstAperturaReport) {
      this.getOrdenesMedicamentos();
    } else {

      this.indicaciones = this.filtros.dataItem.indicaciones;
      this.nombreMedicamento = this.filtros.dataItem.dscrpcnmedicamento;
      this.via = this.filtros.dataItem.via;

      this.dgnstco = this.filtros.dataItem.dgnstco;
      this.dgnstcor1 = this.filtros.dataItem.dgnstcor1;

      this.fechaOrden = this.filtros.dataItem.fcha;
      this.especialidad = this.filtros.dataItem.especialidad;
      this.profesional = this.filtros.dataItem.prfsnl;
      this.registroMedico = this.filtros.dataItem.rgstro_mdco;
    }

  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosControladosComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosControladosComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {

    try {
      this.mensajeLoading = 'Cargando información entidad empresarial ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {

          this.entidadEmpresarial = data[0];
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosControladosComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosControladosComponent.getEntidadEmpresarial()', e);
      // tslint:disable-next-line:max-line-length
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getOrdenesMedicamentos() {
    this.mensajeLoading = 'Cargando medicamento controlado ...';
    const response = await this.ordenamientosService.getMedicamentoControlado(this.parametros, this.filtros.medicamentoControladoSelected);
    response.subscribe((data: any) => {
      data = data['#result-set-1'];
      if (data && data.length > 0) {
        data = data[0];

        this.concentracion = data['Concentracion'];
        this.indicaciones = data['indccns'];
        this.nombreMedicamento = data['dscrpcn_mdcmnto'];
        this.via = data.va_admnstrcn;
        this.dgnstco = data.dgnstco;
        this.fechaOrden = data.fcha_frmla_mdca;
        this.especialidad = data.espclda_pf;
        this.profesional = data['Prfsnl_sld'];
        this.registroMedico = data.rgstr_mdc;
        this.cantidadPrescritaNumerica = data.cntdd;
        this.cantidadPrescritaAlfabetica = data.cantidad_letras;
        this.dgnstcor1 = data.dgnstco1;
        this.formaFarmaceutica = data['Forma_Farmaceutica'];
        this.cnsctvo_mcmnts_ctrlds = data['cnsctvo_mcmnts_ctrlds'];

        this.mensajeLoading = null;
      }

    }, (err: HttpErrorResponse) => {
      console.error('Error ReporteOrdenMedicamentosControladosComponent.getOrdenesMedicamentos()', err);
      // tslint:disable-next-line:max-line-length
      // this.onError('Error al obtener información del medicamento controlado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  async getAfiliado() {
    this.mensajeLoading = 'Cargando afiliado ...';
    const response = await this.ordenamientosService.getAfiliado(this.parametros);
    response.subscribe((data: any) => {
      data = data['#result-set-1'];
      if (data && data.length > 0) {
        data = data[0];

        this.infoOrdenamiento.afiliado.numIdentificacion = data.idntfccn;
        this.infoOrdenamiento.afiliado.tipoId = data.tipo_documento;
        this.infoOrdenamiento.afiliado.nombres = data.nombres;
        this.infoOrdenamiento.afiliado.primer_apellido = data.primer_apellido;
        this.infoOrdenamiento.afiliado.segundo_apellido = data.segundo_apellido;
        this.infoOrdenamiento.afiliado.direccion = data.direccion;
        this.infoOrdenamiento.afiliado.municipio = data.municipio;
        this.infoOrdenamiento.afiliado.departamento = data.departamento;
        this.infoOrdenamiento.afiliado.edad = data.edd;
        this.infoOrdenamiento.afiliado.tipoAfiliado = data.tpo_afldo;
        this.infoOrdenamiento.afiliado.entidad = data.entdd_emprsrl;
        this.infoOrdenamiento.afiliado.telefono = data.telefono;
        this.infoOrdenamiento.afiliado.genero = data.genero;
        this.infoOrdenamiento.afiliado.empresa = data.emprsa;

        this.mensajeLoading = null;
      }

    }, (err: HttpErrorResponse) => {
      console.error('Error ReporteOrdenMedicamentosControladosComponent.getAfiliado()', err);
      // tslint:disable-next-line:max-line-length
      this.onError('Error al obtener información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  onMensajeCarga(mensaje: string) {
    this.mensajeLoading = mensaje;
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }

}
